export interface InventoryItem {
  id: string;
  name: string;
  description: string;
  skuWithUnit: string;
  category: string;
  purchasePrice: number;
  sellingPrice: number;
  gstRate: number;
  hsnCode: string;
  stockQuantity: number;
  minStockLevel: number;
  createdAt: string;
  updatedAt: string;
  userId: string;
  purchaseId?: string;
  lowStock?: boolean;
  stockValue?: number;
  barcode?: string;
  damaged_stock?: number;
  returned_stock?: number;
  last_return_reason?: string;
}

export interface POSReturnRecord {
  id: string;
  date: string;
  productId: string;
  productName: string;
  clientName: string;
  reason: string;
  quantity: number;
  totalValue: number;
  billNumber: string;
  condition: 'restock' | 'writeoff';
  userId: string;
  createdAt: number;
}

export type TransactionType = 'sale' | 'refund';

export interface InventoryCategory {
  id: string;
  name: string;
  description: string;
  userId: string;
}

export interface StockFilter {
  category: string | null;
  lowStock: boolean;
  dateRange: [Date | null, Date | null];
  priceRange: [number | null, number | null];
}

export const INVENTORY_CATEGORIES = [
  "Raw Materials",
  "Finished Goods",
  "Office Supplies",
  "Packaging",
  "Electronics",
  "Furniture",
  "Consumables",
  "Stationery",
  "Spare Parts",
  "Other"
];

export const GST_RATES = [
  { value: 0, label: '0%' },
  { value: 5, label: '5%' },
  { value: 12, label: '12%' },
  { value: 18, label: '18%' },
  { value: 28, label: '28%' }
];

export const UNITS = [
  'Nos-',
  'Kg-',
  'Ltr-',
  'Mtr-',
  'Box-',
  'Pkt-',
  'Set-',
  'Pair-'
]; 